<script lang="ts">
    import { getLocale } from '@amp/web-app-components/src/utils/internal/locale';
    import Korea19Icon from '@amp/web-app-components/assets/icons/korea-19.svg';
    import AR18Icon from '@amp/web-app-components/assets/icons/ar-18.svg';
    import ELAIcon from '@amp/web-app-components/assets/icons/el-A.svg';
    import ExplicitIcon from '@amp/web-app-components/assets/icons/explicit.svg';
    import {
        EL_SF,
        ARABIC_SF,
    } from '@amp/web-app-components/src/components/Explicit/constants';
    import type { Locale } from '@amp/web-app-components/src/types';
    import type { ComponentType } from 'svelte';

    export let explicitAriaText: string | null;

    /**
     * Prevent badge from overflowing into truncation on single-line clamped chin titles.
     */
    export let chinInlineSticky: boolean = false;
    export let locale: Locale = getLocale() ?? null;

    $: icon = (() => {
        let icon: ComponentType = ExplicitIcon;
        if (locale) {
            if (locale.storefront === 'kr') {
                icon = Korea19Icon;
            } else if (
                EL_SF.includes(locale.storefront) &&
                locale.language === 'el'
            ) {
                icon = ELAIcon;
            } else if (ARABIC_SF.includes(locale.storefront)) {
                icon = AR18Icon;
            }
        }
        return icon;
    })();
</script>

<span
    data-testid="explicit-badge"
    class="explicit"
    class:explicit--chin-inline-sticky={chinInlineSticky}
    aria-label={explicitAriaText ? explicitAriaText : null}
    role={explicitAriaText ? 'img' : 'presentation'}
>
    <svelte:component this={icon} />
</span>

<style lang="scss">
    @use 'amp/stylekit/core/mixins/browser-targets' as *;

    .explicit :global(svg) {
        // `auto` falls back on SVG dimensions
        width: var(--explicitBadgeSize, auto);
        height: var(--explicitBadgeSize, auto);
        fill: var(--explicitFillOverride, var(--systemSecondary));
    }

    // Prevent badge from overflowing into truncation on single-line clamped chin titles.
    .explicit--chin-inline-sticky {
        display: inline-grid;
        position: sticky;
        vertical-align: middle;
        transform: translateY(-1.5px); // Alignment, per spec
        margin-inline-start: 2px;
        inset-inline-end: -10px;
        z-index: var(--z-default);

        :global(svg) {
            width: var(--explicitBadgeSize, 11px);
            height: var(--explicitBadgeSize, 11px);
            fill: var(--systemSecondary-onDark);

            @include target-chrome {
                will-change: transform; // Fixes Chrome rendering bug, to make glyph visible
            }
        }
    }
</style>
